Bindable from ../bindable.civet

{ Ergonomics, type FileSystem } from ./util.civet

longestToShortest := (a: string, b: string) ->
  b.length - a.length

type Mounts = Record<string, {
  subsystem: FileSystem
  handler: Function
}>

getMountAndPath := (mounts: Mounts, mountPaths: string[], path: string) =>
  mountPaths = mountPaths.filter (p) =>
    path.startsWith p

  unless mountPaths.length
    throw new Error "No mounted filesystem for #{path}"

  [mountPath] := mountPaths
  mount := mounts[mountPath].subsystem

  subsystemPath := path.replace(mountPath, "/") as `/${string}`

  return [ mount, subsystemPath, mountPath ] as const

export class MountFS with Bindable
  mounts: Record<string, {
    subsystem: FileSystem
    handler: Function
  }> = {}
  mountPaths: string[] = []

  read(path: string, ...params: any[])
    [mount, subsystemPath] := getMountAndPath @mounts, @mountPaths, path

    blob := await mount.read(subsystemPath, ...params)

    if blob
      blob.path = path

    return blob

  write(path: string, blob: Blob, ...params: any[])
    [mount, subsystemPath] := getMountAndPath @mounts, @mountPaths, path

    mount.write(subsystemPath, blob, ...params)

  delete(path: string, ...params: any[])
    [mount, subsystemPath] := getMountAndPath @mounts, @mountPaths, path

    mount.delete(subsystemPath, ...params)

  list(path: string, ...params: any[])
    [mount, subsystemPath, mountPath] := getMountAndPath @mounts, @mountPaths, path

    // Remap paths when retrieving entries
    entries := await mount.list(subsystemPath, ...params)

    entries.map (entry) =>
      Object.assign {}, entry,
        path: entry.path.replace("/", mountPath)

  // S3FS has a local cache, other local systems don't because they are
  // already local. This will call clear cache on any subsystem if it exists.
  clearCache()
    Object.keys(@mounts).forEach (key) =>
      @mounts[key].subsystem
      // @ts-ignore
      .clearCache?()

  mount(mountPath: string, subsystem: FileSystem)
    // Pass all subsystem events through, rewriting the path
    handler := (eventName: string, path: string) =>
      @trigger eventName, path.replace("/", mountPath)

    // Remove previous subsystem handler if present
    if @mounts[mountPath]
      { subsystem: s, handler: h } := @mounts[mountPath]
      s.off "*", h

    subsystem.on "*", handler

    @mounts[mountPath] = { subsystem, handler }
    @mountPaths.push mountPath
    @mountPaths.sort longestToShortest

    return @
